module.exports = __webpack_public_path__ + "img/cpe_icons_location.c0cbca76.svg";